import * as React from "react";
import { Skill } from "../types/skill";
import { useGetSkillsQuery } from "../services/skill.service";
import SelectData from "./global/SelectData";

const SelectSkills = ({
  onChange,
  values,
  label = "Skills",
  error,
  helperText,
}: {
  onChange: (ids?: number[]) => void;
  values: number[];
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const { data: skills, isLoading } = useGetSkillsQuery({
    page: 0,
    pageSize: 2000,
    sortField: "name",
    sortMode: "asc",
  });

  return (
    <SelectData
      data={skills?.data}
      getOptionLabel={(skill) => skill.name}
      getOptionValue={(skill) => skill.id}
      values={values}
      onMultiChange={onChange}
      isMulti={true}
      label={label}
      placeholder="Search skills..."
      error={error}
      helperText={helperText}
      isLoading={isLoading}
    />
  );
};
export default SelectSkills;
